import {SoftNavOnlyLink as Link} from '@github-ui/react-router'
import {ArrowUpRightIcon, ThreeBarsIcon} from '@primer/octicons-react'
import {Button, IconButton, Text} from '@primer/react'

import {COPY} from './CopilotHeaderV2.data'
import Styles from './CopilotHeaderV2.module.css'

export interface CopilotHeaderV2Props {
  onSidebarToggle: () => void
  onSignInClick: () => void
}

export const defaultProps: Partial<CopilotHeaderV2Props> = {}

const CopilotHeaderV2 = (props: CopilotHeaderV2Props) => {
  const initializedProps: CopilotHeaderV2Props = {...defaultProps, ...props}
  const {onSidebarToggle, onSignInClick} = initializedProps

  return (
    <header className={Styles['CopilotHeaderV2']}>
      <div className={Styles['CopilotHeaderV2__sidebarToggle']}>
        <IconButton icon={ThreeBarsIcon} aria-label={COPY.a11y.toggleSidebarButton} onClick={onSidebarToggle} />
      </div>

      <div className={Styles['CopilotHeaderV2__content']}>
        <Link to={COPY.learnMore.href} className={Styles['CopilotHeaderV2__link']} target="_blank">
          <Text weight="semibold">{COPY.learnMore.label}</Text>
          <ArrowUpRightIcon size={16} />
        </Link>

        <Button variant="primary" onClick={onSignInClick}>
          {COPY.signInCta.label}
        </Button>
      </div>
    </header>
  )
}

export default CopilotHeaderV2
